declare global {
  interface Window {
    _env_?: {
      REACT_APP_BASE_URL?: string;
      REACT_APP_BIB_URL?: string;
    };
  }
}

const get = (key: keyof NonNullable<Window["_env_"]>): string | undefined =>
  window._env_?.[key] || process.env[key];

export const BASE_URL = get("REACT_APP_BASE_URL");
export const BIB_URL = get("REACT_APP_BIB_URL");
